var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapClasses,on:{"mouseenter":_vm.mouseenter,"mouseleave":_vm.mouseleave}},[_c('span',{staticClass:"fd-close",on:{"click":function($event){return _vm.close()}}}),_vm._v(" "),_c('div',{staticClass:"fd-text",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49ea52ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/notice/message/index.vue
// module id = null
// module chunks = 